import { cn } from "@/services/hooks/utils";

type SVGSeparatorProps = {
    direction?: "UP" | "DOWN";
};

const SVGSeparator = ({ direction = "DOWN" }: SVGSeparatorProps) => {
    return (
        <div
            className={cn(
                "home-wave",
                direction === "DOWN" ? "rotate-180" : "rotate-0",
            )}
        />
    );
};

export default SVGSeparator;
